import { Capacitor } from '@capacitor/core';

// Web en móvil o tablet (el iPad se identifica como Mac pero tiene pantalla táctil)
export function isMobileWeb(): boolean {
  if (Capacitor.isNativePlatform() || typeof navigator === 'undefined') { return false; }
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
}

/*
 * Si el iframe de Mangopay lleva permiso de cámara: en la app nativa (el WebView se la da con Info.plist y
 * AndroidManifest) y en web móvil, donde Mangopay hace la foto dentro del iframe y sin permiso no funciona.
 * En web de escritorio va sin cámara: Mangopay muestra el QR y la foto se hace en el móvil.
 * Angular no deja enlazar el atributo allow de un iframe (NG0910): la plantilla tiene un iframe para cada caso
 */
export function mangopayIframeCamera(): boolean {
  return Capacitor.isNativePlatform() || isMobileWeb();
}

/*
 * Web móvil: el navegador solo delega la cámara al iframe de Mangopay (otro dominio) si nuestra página ya tiene
 * el permiso; sin él, la página de Mangopay carga pero no puede hacer la foto. Se pide aquí, en el clic del
 * usuario (getUserMedia sin esperas previas, Safari exige el gesto), se apaga al momento y se abre el iframe
 * pase lo que pase: si lo deniega, Mangopay ofrece sus alternativas. En nativo y escritorio no hace nada.
 */
export function requestMobileWebCamera(): Promise<void> {
  if (!isMobileWeb() || !navigator?.mediaDevices?.getUserMedia) {
    return Promise.resolve();
  }
  return navigator.mediaDevices.getUserMedia({ video: true })
    .then(stream => stream.getTracks().forEach(track => track.stop()))
    .catch(() => undefined);
}
